<template>
  <v-layout row wrap justify-center class="folder-info-card elevation-2">

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Descricão</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">
      <span v-if="folder.subject">{{ folder.subject }}</span>
      <v-btn
          v-if="folder.folder_status.name !== 'Arquivado'"
          class="my-0 pa-0 custom-button"
          color="blue"
          flat
          icon
          small
          @click="showDialogSubjectFolder = true"
      >
        <v-icon size="16">mdi-pencil</v-icon>
      </v-btn>
    </v-flex>

<!--    <template>-->
<!--      <v-flex xs5 class="pr-2 my-2 grey&#45;&#45;text text-xs-right">-->
<!--        <small>Resumo</small>-->
<!--      </v-flex>-->
<!--      <v-flex xs7>-->

<!--        <div style="font-family: Avenir, Open Sans, Helvetica, Arial, sans-serif">-->
<!--          <v-btn color="black" dark depressed @click="handleShowAiResume()">-->
<!--            <svg class="mr-2" fill="white" width="16px" viewBox="0 0 512 512" id="icons"-->
<!--                 xmlns="http://www.w3.org/2000/svg">-->
<!--              <path-->
<!--                  d="M208,512a24.84,24.84,0,0,1-23.34-16l-39.84-103.6a16.06,16.06,0,0,0-9.19-9.19L32,343.34a25,25,0,0,1,0-46.68l103.6-39.84a16.06,16.06,0,0,0,9.19-9.19L184.66,144a25,25,0,0,1,46.68,0l39.84,103.6a16.06,16.06,0,0,0,9.19,9.19l103,39.63A25.49,25.49,0,0,1,400,320.52a24.82,24.82,0,0,1-16,22.82l-103.6,39.84a16.06,16.06,0,0,0-9.19,9.19L231.34,496A24.84,24.84,0,0,1,208,512Zm66.85-254.84h0Z"/>-->
<!--              <path-->
<!--                  d="M88,176a14.67,14.67,0,0,1-13.69-9.4L57.45,122.76a7.28,7.28,0,0,0-4.21-4.21L9.4,101.69a14.67,14.67,0,0,1,0-27.38L53.24,57.45a7.31,7.31,0,0,0,4.21-4.21L74.16,9.79A15,15,0,0,1,86.23.11,14.67,14.67,0,0,1,101.69,9.4l16.86,43.84a7.31,7.31,0,0,0,4.21,4.21L166.6,74.31a14.67,14.67,0,0,1,0,27.38l-43.84,16.86a7.28,7.28,0,0,0-4.21,4.21L101.69,166.6A14.67,14.67,0,0,1,88,176Z"/>-->
<!--              <path-->
<!--                  d="M400,256a16,16,0,0,1-14.93-10.26l-22.84-59.37a8,8,0,0,0-4.6-4.6l-59.37-22.84a16,16,0,0,1,0-29.86l59.37-22.84a8,8,0,0,0,4.6-4.6L384.9,42.68a16.45,16.45,0,0,1,13.17-10.57,16,16,0,0,1,16.86,10.15l22.84,59.37a8,8,0,0,0,4.6,4.6l59.37,22.84a16,16,0,0,1,0,29.86l-59.37,22.84a8,8,0,0,0-4.6,4.6l-22.84,59.37A16,16,0,0,1,400,256Z"/>-->
<!--            </svg>-->
<!--            Resumir-->
<!--            <div-->
<!--                style="position: absolute; top: -15px; right: -40px; border: 2px solid white; padding: 2px 3px; color: white; font-size: 9px; background-color: #2E8BFF; border-radius: 10px">-->
<!--              <span style="position: relative; bottom: -2px">Novo</span>-->
<!--            </div>-->
<!--          </v-btn>-->
<!--        </div>-->
<!--      </v-flex>-->
<!--    </template>-->


    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>{{ externalProtocolName }}</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">
      <span v-if="folder.number">{{ folder.number }}</span>
      <v-btn
          v-if="folder.number"
          class="my-0 pa-0 custom-button"
          color="blue"
          flat
          icon
          small
          @click="showDialog = true"
      >
        <v-icon size="16">mdi-pencil</v-icon>
      </v-btn>
      <v-btn
          v-else
          class="pa-0 my-0 custom-button"
          small
          flat
          color="blue"
          @click="showDialog = true"
      >
        Adicionar
        <v-icon right size="16">mdi-plus</v-icon>
      </v-btn>
    </v-flex>

    <v-flex v-if="folder.confidential" xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Visibilidade</small>
    </v-flex>
    <v-flex v-if="folder.confidential" xs7 class="pl-2 my-2 process-restricted">Processo Restrito</v-flex>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Última Alteração</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">{{ formatDateTime(folder.last_modification_at) }}</v-flex>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Criação</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">{{ formatDateTime(folder.created_at) }}</v-flex>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Status</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">{{ folder.folder_status.name || "" }}</v-flex>

    <v-dialog
        v-model="showAiResumeDialog"
        width="600"
        persistent
    >
      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between" style="width: 100%">
            <h4 class="headline">Resumo</h4>

            <!-- Botão de gerar novamente caso seja super admin -->
            <v-btn
                v-if="user.super_admin"
                color="black"
                flat
                @click="handleShowAiResume(true)"
                small
            >
              <v-icon>mdi-refresh</v-icon>
              Gerar novamente
            </v-btn>
          </div>
        </v-card-title>
        <div v-if="generatingAiResume" class="d-flex"
             style="justify-content: center; align-items: center; flex-direction: column">
          <div class="pa-3 d-flex"
               style="flex-direction: column; align-items: center; justify-content: center; width: 70%">
            <svg class="magic-staff" width="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>
              magic-staff</title>
              <path
                  d="M17.5 9C16.12 9 15 7.88 15 6.5S16.12 4 17.5 4 20 5.12 20 6.5 18.88 9 17.5 9M14.43 8.15L2 20.59L3.41 22L15.85 9.57C15.25 9.24 14.76 8.75 14.43 8.15M13 5L13.63 3.63L15 3L13.63 2.37L13 1L12.38 2.37L11 3L12.38 3.63L13 5M21 5L21.63 3.63L23 3L21.63 2.37L21 1L20.38 2.37L19 3L20.38 3.63L21 5M21 9L20.38 10.37L19 11L20.38 11.63L21 13L21.63 11.63L23 11L21.63 10.37L21 9Z"/>
            </svg>
            <v-progress-linear indeterminate color="blue"></v-progress-linear>
          </div>
          <p>Gerando resumo...</p>
        </div>
        <v-card-text id="ai-content-resume">
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn type="button" flat color="black" @click="showAiResumeDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="showDialog"
        width="600"
        persistent
    >
      <v-card>
        <v-card-title
            class="headline grey lighten-2"
            primary-title>
          <h4 class="headline">Informar {{ externalProtocolName }}</h4>
        </v-card-title>

        <v-form @submit.prevent="saveNumber" v-model="valid">
          <v-card-text class="no-overflow">
            <v-layout justify-center align-center>
              <!-- <strong class="grey--text text--darken-1 mr-3">4903 - </strong> -->
              <v-text-field
                  :label="`${externalProtocolName}`"
                  solo
                  style="max-height: 55px"
                  v-model="number"
                  :rules="[validationRules.required]"
              />
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn type="button" flat color="black" @click="cancel('number')">Cancelar</v-btn>
            <v-btn type="submit" flat color="blue" :disabled="!valid">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showDialogSubjectFolder"
        width="600"
    >
      <v-card>
        <v-card-title
            class="headline grey lighten-2"
            primary-title>
          <h4 class="headline">Alterar Descrição da Pasta</h4>
        </v-card-title>

        <v-form @submit.prevent="saveSubject" v-model="validSubject">
          <v-card-text class="no-overflow">
            <v-layout justify-center align-center>
              <!-- <strong class="grey--text text--darken-1 mr-3">4903 - </strong> -->
              <v-textarea
                  label="Descrição da Pasta"
                  maxlength="250"
                  counter
                  solo
                  no-resize
                  v-model="subject"
                  :rules="[validationRules.required]"
              />
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn type="button" flat color="black" @click="cancel('subject')">Cancelar</v-btn>
            <v-btn type="submit" flat color="blue" :disabled="!validSubject">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import {capitalize} from 'lodash';
import validationRules from '@/mixins/validation-rules';
import externalProtocolName from '@/utils/external-protocol-name';
import {HtmlWriter} from "../../../mixins/html-writer/html-writer";

export default {
  name: 'folder-info',
  data() {
    return {
      showDialog: false,
      showDialogSubjectFolder: false,
      number: '',
      subject: '',
      valid: false,
      validSubject: false,
      showingCompleteAiResume: false,
      showAiResumeDialog: false,
      validationRules,
    };
  },
  methods: {
    animateAiResume(text = '') {
      const el = document.getElementById('ai-content-resume');
      el.html = '';

      if (!text) return;

      HtmlWriter.fromHtmlString(text).writeTo(el);
    },
    handleShowAiResume(force = false) {
      this.showAiResumeDialog = true;

      force = force === true;

      if (this.folder.ai_resume && !force) {
        this.animateAiResume(this.formatResume(this.folder.ai_resume));

        return;
      }

      this.$store.dispatch('generateAiResume', {folderId: this.folder.id})
          .then(() => {
            this.animateAiResume(this.formatResume(this.folder.ai_resume));
          });
    },
    formatResume(text) {
      // TODO: Isso será desnecessário, pois agora o back-end salva em HTML em vez de markdown
      if (!text) return '';

      return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\*(.*?)\*/g, '<em>$1</em>');
    },
    formatDateTime(dateTime) {
      const date = format(dateTime, 'DD', {locale: ptLocale});
      const month = format(dateTime, 'MMMM', {locale: ptLocale});
      const year = format(dateTime, 'YYYY', {locale: ptLocale});
      return `${date} de ${capitalize(month)} de ${year}`;
    },
    saveNumber() {
      const body = {
        folder: {
          number: this.number,
        },
        id: this.folder.id,
      };
      this.$store.dispatch('addNumber', body);
      this.showDialog = false;
    },
    cancel(field) {
      this.showDialog = false;
      this.showDialogSubjectFolder = false;
      this[field] = this.folder[field];
    },
    saveSubject() {
      const body = {
        folder: {
          subject: this.subject,
        },
        id: this.folder.id,
      };
      this.$store.dispatch('updateSubject', body);
      this.showDialogSubjectFolder = false;
    },
  },
  computed: {
    folder() {
      this.number = this.$store.getters.activeFolder.number;
      this.subject = this.$store.getters.activeFolder.subject;
      return this.$store.getters.activeFolder;
    },
    generatingAiResume() {
      return this.$store.getters.isGeneratingAiResume;
    },
    externalProtocolName() {
      return externalProtocolName();
    },
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style scoped>
.folder-info-card {
  background: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  padding: 18px 12px 12px 12px;
  margin: 8px 0;
  transition: box-shadow 0.3s cubic-bezier(0.4,0,0.2,1), background 0.3s;
  min-width: 260px;
  max-width: 420px;
  width: 100%;
  position: relative;
}
.folder-info-card .v-flex {
  transition: background 0.2s;
}

.folder-info-card .pr-2, .folder-info-card .pl-2 {
  padding-right: 8px !important;
  padding-left: 8px !important;
}

.folder-info-card .my-2 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.folder-info-card small {
  font-weight: 600;
  color: #607d8b;
  letter-spacing: 0.2px;
}

.folder-info-card span, .folder-info-card .process-restricted {
  font-size: 13px;
  color: #222;
  word-break: break-word;
}

.folder-info-card .process-restricted {
  color: #ff9800;
  font-weight: 600;
}

.folder-info-card .v-btn.custom-button {
  border-radius: 50%;
  transition: box-shadow 0.2s, background 0.2s;
  margin-left: 4px;
  margin-right: 2px;
  min-width: 24px;
  min-height: 24px;
  box-shadow: 0 1px 4px rgba(33,150,243,0.08);
}
.folder-info-card .v-btn.custom-button:hover {
  background: #e3f2fd !important;
  box-shadow: 0 2px 8px rgba(33,150,243,0.15);
}

.folder-info-card .v-icon {
  vertical-align: middle;
}


.folder-info-card .v-dialog .v-card {
  border-radius: 10px;
}


  .folder-info-card .v-dialog .v-card-title {
  border-radius: 10px 10px 0 0;
}

.folder-info-card .v-dialog .v-btn {
  border-radius: 6px;
}

.folder-info-card .v-dialog .v-text-field, .folder-info-card .v-dialog .v-textarea {
  font-size: 14px;
}

.folder-info-card .v-dialog .v-card-actions {
  padding-bottom: 12px;
}

.folder-info-card .badge-status {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: linear-gradient(90deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1976d2;
  margin-left: 6px;
  animation: pulse-badge 1.2s infinite alternate;
  box-shadow: 0 1px 4px rgba(33,150,243,0.08);
}

@keyframes pulse-badge {
  from { box-shadow: 0 0 0 0 rgba(33,150,243,0.15); }
  to { box-shadow: 0 0 8px 2px rgba(33,150,243,0.18); }
}

.folder-info-card .v-flex[aria-label], .folder-info-card [aria-label] {
  cursor: help;
}

@media (max-width: 600px) {
  .folder-info-card {
    min-width: 100%;
    max-width: 100%;
    padding: 10px 2px 8px 2px;
  }
}

/* keyframe para ficar brilhando o icone de magic-staff em escala cinza */
@keyframes shine {
  0% {
    fill: #ccc;
    transform: scale(1);
  }
  50% {
    fill: #919191;
    transform: scale(1.1);
  }
  100% {
    fill: #ccc;
    transform: scale(1);
  }
}

/* icone de magic-staff */
.magic-staff {
  width: 100px;
  height: 100px;
  animation: shine 1s infinite;
}

#ai-content-resume h1 {
  font-size: 1.5em;
}

#ai-content-resume h2 {
  font-size: 1.3em;
}

#ai-content-resume h3 {
  font-size: 1.1em;
}

#ai-content-resume h4 {
  font-size: 1em;
}

#ai-content-resume h5 {
  font-size: 0.9em;
}

#ai-content-resume h6 {
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/folder/info/FolderInfo.vue